/**
 * @desc 公司对账分页列表
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.PageRequest<defs.ComeOnReconciliationQueryParameters>): Promise<BaseResponse<defs.PageBean<Array<defs.ComeOnReconciliationPageListsCompany>>>> {
  return fetch({
    url: config.API_HOST + '/fuel/fee/companyReconciliationPageList',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
